import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { STORE_NAME } from '../../variables';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {

  form:FormGroup ;

  constructor(
    private router : Router,
    private fb: FormBuilder
    ) {
    this.form = this.fb.group({
      searchValue: new FormControl("",[Validators.required,Validators.min(1),Validators.max(50)]),
    })
   }

   navigateToProducts() {
     this.router.navigate(["products"])
   }

   navigateToHome() {
    this.router.navigate(["home"])
  }

  search() {
    if(this.form.valid){
      this.router.navigate(["search",this.form.get('searchValue').value])
    }
  }
}
